"use strict";

import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import PaletteIcon from "@mui/icons-material/Palette";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";

import {
  REMIX_CHARACTER_VOICE,
  DESIGN_CHARACTER_VOICE,
} from "../../ApiEndpoints.js";

export const VOICE_CREATION_MODES = {
  remix: {
    value: "remix",
    label: "Voice Remix",
    shortLabel: "Remix",
    description:
      "Transform one or more characters' voices with a prompt. Each character is remixed on its own.",
    endpoint: REMIX_CHARACTER_VOICE,
    allowMultipleCharacters: true,
    defaultVoiceDescription: "Make this voice have a Mexican Accent",
    icon: GraphicEqIcon,
    enabled: true,
  },
  design: {
    value: "design",
    label: "Voice Design",
    shortLabel: "Design",
    description:
      "Design a new voice variation for one selected character using only the prompt.",
    endpoint: DESIGN_CHARACTER_VOICE,
    allowMultipleCharacters: false,
    defaultVoiceDescription: "Design a warm, calm, natural character voice",
    icon: PaletteIcon,
    enabled: true,
  },
  match: {
    value: "match",
    label: "Voice Match",
    shortLabel: "Match",
    description:
      "Match or compare voices against character references. This section will be added later.",
    endpoint: null,
    allowMultipleCharacters: false,
    defaultVoiceDescription: "",
    icon: CompareArrowsIcon,
    enabled: false,
  },
};
